import React, {memo} from "react";
import {useTranslation} from "react-i18next";
//local
import SubHeading from "components/SubHeading";
import CustomRadioSwitch from "components/CustomRadioSwitch";
import {IconContractNumber} from "components/icons";

const ContractNumbersSettings = memo(({settings, onUpdate}) => {
  const {t} = useTranslation();

  return (
    <div className="organization-settings__contract-number mb-12">
      <SubHeading
        title="SETTINGS_ORGANIZATION_CONTRACT_NUMBERS"
        icon={<IconContractNumber />}
      />
      <CustomRadioSwitch
        checked={settings?.showContractNumber}
        mediumText
        label={t("SETTINGS_ORGANIZATION_CONTRACT_NUMBERS_SWITCH_LABEL")}
        small
        addWrapperClass="mt-4"
        informationText="SETTINGS_ORGANIZATION_CONTRACT_NUMBERS_SWITCH_TOOLTIP"
        isActive={(checked) => onUpdate({showContractNumber: checked})}
      />
    </div>
  );
});

export default ContractNumbersSettings;
